export default {
  path: '/wecode/weForm-fill',
  auth: false,
  preload: false,
  key: 'weForm',
  component: () => import('./index')
};
